/**
 * Fragmentos de búsqueda: la API marca las coincidencias con «…» (ts_headline
 * con StartSel/StopSel de texto, nunca HTML). Se parten en trozos para
 * pintarlos con <mark> sin usar innerHTML.
 */
export interface Piece {
  text: string
  hit: boolean
}

export function splitHighlight(fragment: string): Piece[] {
  const out: Piece[] = []
  const re = /«([^«»]*)»/g
  let last = 0
  for (let m = re.exec(fragment); m; m = re.exec(fragment)) {
    if (m.index > last) out.push({ text: fragment.slice(last, m.index), hit: false })
    if (m[1]) out.push({ text: m[1], hit: true })
    last = m.index + m[0].length
  }
  if (last < fragment.length) out.push({ text: fragment.slice(last), hit: false })
  return out
}
